import script from "./FeedFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedFilters.vue?vue&type=script&setup=true&lang=js"

import "./FeedFilters.vue?vue&type=style&index=0&id=1c8e7018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8e7018"]])

export default __exports__